import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { HttpModule } from '@angular/http';

import { AboutModule } from './about/about.module';
import { AppRoutingModule } from './app.routing.module';
import { ClinicalStaffModule } from './clinical-staff/clinical-staff.module';
import { ContactModule } from './contact/contact.module';
import { ServicesModule } from './services/services.module';
import { SharedModule } from './shared/shared.module';
import { TipsModule } from './tips/tips.module';

import { AppComponent } from './app.component';
import { HomeComponent } from './home/home.component';

import { HttpUtilService } from './config/http-util.service';

@NgModule({
  declarations: [
    AppComponent,
	HomeComponent,
  ],
  imports: [
	AppRoutingModule,
	AboutModule,
	BrowserModule,
	ClinicalStaffModule,
	ContactModule,
	HttpModule,
	ServicesModule,
	SharedModule,
	TipsModule
  ],
  providers: [
    HttpUtilService
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }



// WEBPACK FOOTER //
// /Users/henriquezanini/Sites/Cães e Gatos/site/src/app/app.module.ts